import React from "react";

function NoMobile() {
  return (
    <div className="containers">
      <h1>Mobile friendly site coming soon!</h1>
      <h2>Please open it in Desktop/Laptop.</h2>
      <img
        src={require("../media/no-phone.png").default}
        alt="no-mobile-icon"
        id="no-mobile-icon"
      />
    </div>
  );
}

export default NoMobile;
